import { onDomLoaded } from 'utils/onLoaded';
import polyfill from 'utils/polyfill';
import initOrganisms from 'utils/initOrganisms';

function isValidSelector(selector) {
  try {
    document.querySelector(selector);
    return true;
  } catch (e) {
    if (e instanceof DOMException && e.name === 'SyntaxError') {
      return false;
    }
    throw e;
  }
}

function init() {
  polyfill.init();
  initOrganisms(document);

  // Re-run init scoped to any container that just had AJAX content injected.
  // AjaxLoad dispatches `organisms:loaded` (bubbles) on the loaded element.
  document.addEventListener('organisms:loaded', (event) => {
    const root = event.detail && event.detail.root;
    if (root) initOrganisms(root);
  });
}

onDomLoaded(init);
window.onload = function() {
  if (window.location.hash && isValidSelector(window.location.hash)) {
    const targetElement = document.querySelector(window.location.hash);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
};
